import React from "react";
import styled from 'styled-components'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/pagination";
import { EffectCube, Pagination } from "swiper";

import hotel1 from '../assets/hotel1.jpg'
import hotel2 from '../assets/beachotl2.jpg'
import hotel3 from '../assets/hotel3.jpg'
import hotel4 from '../assets/hotel4.jpg'

import asd from '../assets/hotels/hotel104.jpg'
import zxc from '../assets/hotels/hotel106.jpg'



const Container = styled.div`
width: auto;
height: auto;

.swiper{
  width: 300px;
  height: 300px;
  position: absolute;
  left: 5%;
  top: -10%;

  img{
    width: 300px;
    height: 300px;
    /* object-fit: cover; */
  }
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}

.swiper-slide img {
 
  display: block;
  width: 100%;
}
`

const AccomCube = () => {
  return (
    <Container>
    <Swiper
      effect={"cube"}
      grabCursor={true}
      cubeEffect={{
        shadow: true,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      }}
      pagination={true}
      modules={[EffectCube, Pagination]}
      className="mySwiper"
    >
      <SwiperSlide>
        <img src={hotel1} alt="accomo1" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={hotel2} alt="accomo2" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={asd} alt="accomo3" />
      </SwiperSlide>
      <SwiperSlide>
        <img src={zxc} alt="accomo4" />
      </SwiperSlide>
    </Swiper>
  </Container>
  )
}

export default AccomCube